"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-misused-promises */
var react_1 = __importStar(require("react"));
var react_hook_form_1 = require("react-hook-form");
var react_router_dom_1 = require("react-router-dom");
require("../assets/styles/2fa.css");
var Button_1 = __importDefault(require("../components/Button"));
var FaHeader_1 = __importDefault(require("../utils/FaHeader"));
var axios_1 = require("axios");
var react_hot_toast_1 = __importStar(require("react-hot-toast"));
var AxiosClient_1 = require("../utils/AxiosClient");
function Setup2FA() {
    var _a;
    var _b = (0, react_1.useState)(""), phone_number = _b[0], setPhone = _b[1];
    document.title = "Setup two-step verification";
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _c = (0, react_1.useState)(false), isResponseArrived = _c[0], setResponseStatus = _c[1];
    var _d = (0, react_1.useState)(false), loading = _d[0], setLoading = _d[1];
    var sendcode = function (phone) {
        setLoading(true);
        react_hot_toast_1.default.loading("Sending your request...");
        AxiosClient_1.AxiosClient.get("/sendcode/".concat(phone))
            .then(function (response) {
            if (response.data.status == 200) {
                setPhone(response.data.codeSentTo);
                setResponseStatus(true);
            }
            else {
                react_hot_toast_1.default.error("Something went wrong!");
            }
        })
            .catch(function (error) {
            if ((0, axios_1.isAxiosError)(error)) {
                react_hot_toast_1.default.error("Axios error: ".concat(error.message));
            }
            else {
                react_hot_toast_1.default.error("Something went wrong");
            }
        })
            .finally(function () { return setLoading(false); });
    };
    var _e = (0, react_hook_form_1.useForm)(), register = _e.register, handleSubmit = _e.handleSubmit, errors = _e.formState.errors;
    var phone;
    var minimum = {
        value: 13,
        message: "Phone number should be at least 13 characters",
    };
    var maximum = {
        value: 15,
        message: "Phone number should be less than 15 characters",
    };
    var onSubmit = handleSubmit(function (data) {
        phone = data.phoneNumber;
        sendcode(phone);
    });
    (0, react_1.useEffect)(function () {
        if (isResponseArrived) {
            react_hot_toast_1.default.remove();
            react_hot_toast_1.default.success("Verification Sent!", { duration: 3000 });
            setTimeout(function () {
                navigate("/verify-code", { state: { phone_number: phone_number } });
            }, 2000);
        }
    }, [isResponseArrived]);
    return (react_1.default.createElement("div", { className: "setupContainer" },
        react_1.default.createElement(FaHeader_1.default, null),
        react_1.default.createElement("div", { className: "body-text" },
            react_1.default.createElement("p", null,
                "As a seller you need to enable 2-step authentication for maximum security",
                " "),
            react_1.default.createElement("h3", null, "Set up two-factor authentication")),
        react_1.default.createElement("form", { onSubmit: onSubmit },
            react_1.default.createElement("input", __assign({ style: {
                    borderColor: ((_a = errors.phoneNumber) === null || _a === void 0 ? void 0 : _a.type) == "required" ? "red" : "",
                }, type: "tel", placeholder: "+250788888888", pattern: "[0-9,+]+" }, register("phoneNumber", {
                required: true,
                minLength: minimum,
                maxLength: maximum,
            }), { autoComplete: "off" })),
            (errors === null || errors === void 0 ? void 0 : errors.phoneNumber) && (react_1.default.createElement("p", { className: "error" }, errors.phoneNumber.message)),
            react_1.default.createElement(Button_1.default, { text: "Get Code", disabled: loading, type: "submit" })),
        react_1.default.createElement(react_hot_toast_1.Toaster, null)));
}
exports.default = Setup2FA;
